"use strict";
/* tslint:disable */
/* eslint-disable */
Object.defineProperty(exports, "__esModule", { value: true });
exports.InventoryApi = exports.InventoryApiAxiosParamCreator = void 0;
const axios_1 = require("axios");
// Some imports not used depending on template conditions
// @ts-ignore
const common_1 = require("../common");
// @ts-ignore
const base_1 = require("../base");
// @ts-ignore
const models_1 = require("../models");
// @ts-ignore
const models_2 = require("../models");
/**
 * InventoryApi - axios parameter creator
 * @export
 */
const InventoryApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        calculateTotalInventoryValue: async (options = {}) => {
            const localVarPath = `/api/inventory/calculate-total-inventory-value`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // http bearer authentication if accessToken is configured
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTestInventory: async (options = {}) => {
            const localVarPath = `/api/inventory/create-test-inventory`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // http bearer authentication if accessToken is configured
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {InlineObject7} inlineObject7
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        decreaseInventory: async (inlineObject7, options = {}) => {
            // verify required parameter 'inlineObject7' is not null or undefined
            (0, common_1.assertParamExists)('decreaseInventory', 'inlineObject7', inlineObject7);
            const localVarPath = `/api/inventory/decrease-inventory`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // http bearer authentication if accessToken is configured
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(inlineObject7, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} inventoryId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteInventory: async (inventoryId, options = {}) => {
            // verify required parameter 'inventoryId' is not null or undefined
            (0, common_1.assertParamExists)('deleteInventory', 'inventoryId', inventoryId);
            const localVarPath = `/api/inventory/delete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // http bearer authentication if accessToken is configured
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (inventoryId !== undefined) {
                localVarQueryParameter['inventory_id'] = inventoryId;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} productId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInventoryForProduct: async (productId, options = {}) => {
            // verify required parameter 'productId' is not null or undefined
            (0, common_1.assertParamExists)('getInventoryForProduct', 'productId', productId);
            const localVarPath = `/api/inventory`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // http bearer authentication if accessToken is configured
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (productId !== undefined) {
                localVarQueryParameter['productId'] = productId;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {InlineObject5} inlineObject5
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInventoryListPost: async (inlineObject5, options = {}) => {
            // verify required parameter 'inlineObject5' is not null or undefined
            (0, common_1.assertParamExists)('getInventoryListPost', 'inlineObject5', inlineObject5);
            const localVarPath = `/api/inventory/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // http bearer authentication if accessToken is configured
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(inlineObject5, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {InlineObject6} inlineObject6
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        increaseInventory: async (inlineObject6, options = {}) => {
            // verify required parameter 'inlineObject6' is not null or undefined
            (0, common_1.assertParamExists)('increaseInventory', 'inlineObject6', inlineObject6);
            const localVarPath = `/api/inventory/increase-inventory`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // http bearer authentication if accessToken is configured
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(inlineObject6, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {IInventoryEntity} iInventoryEntity
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        upsertInventory: async (iInventoryEntity, options = {}) => {
            // verify required parameter 'iInventoryEntity' is not null or undefined
            (0, common_1.assertParamExists)('upsertInventory', 'iInventoryEntity', iInventoryEntity);
            const localVarPath = `/api/inventory/upsert-inventory`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // http bearer authentication if accessToken is configured
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(iInventoryEntity, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
exports.InventoryApiAxiosParamCreator = InventoryApiAxiosParamCreator;
/**
 * InventoryApi -
 */
var InventoryApi;
(function (InventoryApi) {
    /**
     *
     * @param {*} [options] Override http request option.
     * @param {*} [configuration] Override the defaultConfiguration
     * @throws {RequiredError}
     * @memberof InventoryApi
     * url /api/inventory/calculate-total-inventory-value
     */
    async function calculateTotalInventoryValue(options, configuration = common_1.defaultConfiguration) {
        const localVarAxiosParamCreator = (0, exports.InventoryApiAxiosParamCreator)(configuration);
        const localVarAxiosArgs = await localVarAxiosParamCreator.calculateTotalInventoryValue(options);
        const axiosRequest = (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        return axiosRequest(axios_1.default, (0, common_1.getBasePath)(configuration))
            .then(res => {
            return res;
        });
    }
    InventoryApi.calculateTotalInventoryValue = calculateTotalInventoryValue;
    /**
     *
     * @param {*} [options] Override http request option.
     * @param {*} [configuration] Override the defaultConfiguration
     * @throws {RequiredError}
     * @memberof InventoryApi
     * url /api/inventory/create-test-inventory
     */
    async function createTestInventory(options, configuration = common_1.defaultConfiguration) {
        const localVarAxiosParamCreator = (0, exports.InventoryApiAxiosParamCreator)(configuration);
        const localVarAxiosArgs = await localVarAxiosParamCreator.createTestInventory(options);
        const axiosRequest = (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        return axiosRequest(axios_1.default, (0, common_1.getBasePath)(configuration));
    }
    InventoryApi.createTestInventory = createTestInventory;
    /**
     *
     * @param {InlineObject7} inlineObject7
     * @param {*} [options] Override http request option.
     * @param {*} [configuration] Override the defaultConfiguration
     * @throws {RequiredError}
     * @memberof InventoryApi
     * url /api/inventory/decrease-inventory
     */
    async function decreaseInventory(inlineObject7, options, configuration = common_1.defaultConfiguration) {
        const localVarAxiosParamCreator = (0, exports.InventoryApiAxiosParamCreator)(configuration);
        const localVarAxiosArgs = await localVarAxiosParamCreator.decreaseInventory(inlineObject7, options);
        const axiosRequest = (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        return axiosRequest(axios_1.default, (0, common_1.getBasePath)(configuration))
            .then(res => {
            res.data = (0, models_2.parseIInventoryEntity)(res.data);
            return res;
        });
    }
    InventoryApi.decreaseInventory = decreaseInventory;
    /**
     *
     * @param {number} inventoryId
     * @param {*} [options] Override http request option.
     * @param {*} [configuration] Override the defaultConfiguration
     * @throws {RequiredError}
     * @memberof InventoryApi
     * url /api/inventory/delete
     */
    async function deleteInventory(inventoryId, options, configuration = common_1.defaultConfiguration) {
        const localVarAxiosParamCreator = (0, exports.InventoryApiAxiosParamCreator)(configuration);
        const localVarAxiosArgs = await localVarAxiosParamCreator.deleteInventory(inventoryId, options);
        const axiosRequest = (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        return axiosRequest(axios_1.default, (0, common_1.getBasePath)(configuration));
    }
    InventoryApi.deleteInventory = deleteInventory;
    /**
     *
     * @param {number} productId
     * @param {*} [options] Override http request option.
     * @param {*} [configuration] Override the defaultConfiguration
     * @throws {RequiredError}
     * @memberof InventoryApi
     * url /api/inventory
     */
    async function getInventoryForProduct(productId, options, configuration = common_1.defaultConfiguration) {
        const localVarAxiosParamCreator = (0, exports.InventoryApiAxiosParamCreator)(configuration);
        const localVarAxiosArgs = await localVarAxiosParamCreator.getInventoryForProduct(productId, options);
        const axiosRequest = (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        return axiosRequest(axios_1.default, (0, common_1.getBasePath)(configuration))
            .then(res => {
            res.data = res.data.map((x) => (0, models_2.parseIInventoryEntity)(x));
            return res;
        });
    }
    InventoryApi.getInventoryForProduct = getInventoryForProduct;
    /**
     *
     * @param {InlineObject5} inlineObject5
     * @param {*} [options] Override http request option.
     * @param {*} [configuration] Override the defaultConfiguration
     * @throws {RequiredError}
     * @memberof InventoryApi
     * url /api/inventory/list
     */
    async function getInventoryListPost(inlineObject5, options, configuration = common_1.defaultConfiguration) {
        const localVarAxiosParamCreator = (0, exports.InventoryApiAxiosParamCreator)(configuration);
        const localVarAxiosArgs = await localVarAxiosParamCreator.getInventoryListPost(inlineObject5, options);
        const axiosRequest = (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        return axiosRequest(axios_1.default, (0, common_1.getBasePath)(configuration))
            .then(res => {
            res.data = (0, models_1.parseBatchResponseIInventoryExtendedEntity)(res.data);
            return res;
        });
    }
    InventoryApi.getInventoryListPost = getInventoryListPost;
    /**
     *
     * @param {InlineObject6} inlineObject6
     * @param {*} [options] Override http request option.
     * @param {*} [configuration] Override the defaultConfiguration
     * @throws {RequiredError}
     * @memberof InventoryApi
     * url /api/inventory/increase-inventory
     */
    async function increaseInventory(inlineObject6, options, configuration = common_1.defaultConfiguration) {
        const localVarAxiosParamCreator = (0, exports.InventoryApiAxiosParamCreator)(configuration);
        const localVarAxiosArgs = await localVarAxiosParamCreator.increaseInventory(inlineObject6, options);
        const axiosRequest = (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        return axiosRequest(axios_1.default, (0, common_1.getBasePath)(configuration))
            .then(res => {
            res.data = (0, models_2.parseIInventoryEntity)(res.data);
            return res;
        });
    }
    InventoryApi.increaseInventory = increaseInventory;
    /**
     *
     * @param {IInventoryEntity} iInventoryEntity
     * @param {*} [options] Override http request option.
     * @param {*} [configuration] Override the defaultConfiguration
     * @throws {RequiredError}
     * @memberof InventoryApi
     * url /api/inventory/upsert-inventory
     */
    async function upsertInventory(iInventoryEntity, options, configuration = common_1.defaultConfiguration) {
        const localVarAxiosParamCreator = (0, exports.InventoryApiAxiosParamCreator)(configuration);
        const localVarAxiosArgs = await localVarAxiosParamCreator.upsertInventory(iInventoryEntity, options);
        const axiosRequest = (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        return axiosRequest(axios_1.default, (0, common_1.getBasePath)(configuration))
            .then(res => {
            res.data = (0, models_2.parseIInventoryEntity)(res.data);
            return res;
        });
    }
    InventoryApi.upsertInventory = upsertInventory;
})(InventoryApi || (exports.InventoryApi = InventoryApi = {}));
